import React, { useContext } from 'react';
import { LocalContext } from 'context';
import styled from 'styled-components';

const ModalTrigger = ({ buttonRef, trigger, showModal, disableModal }) => {
  const { scrollTo, registerRef } = useContext(LocalContext);
  return (
    <ModalButton
      ref={buttonRef}
      onClick={() => (disableModal ? scrollTo(registerRef) : showModal())}>
      {trigger}
    </ModalButton>
  );
};

const ModalButton = styled.div`
  background: transparent;
  cursor: pointer;
`;

export default ModalTrigger;
